// extracted by mini-css-extract-plugin
export default {"contact":"WhereToBuy_contact__8fM9h","shop":"WhereToBuy_shop__FZXgI","text_warning":"WhereToBuy_text_warning__d89P7"};